import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { isValueNumber } from 'src/utils/typeValidators';
const PreviewCycleChargesModal = observer(_ref => {
  var _store$allocations$ch;
  let disabled = _ref.disabled;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const renderCell = (parameter, left) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, parameter);
  const renderHeader = (text, right) => /*#__PURE__*/React.createElement("span", {
    className: right && classes.rightAlign
  }, text);
  const columns = [{
    align: 'right',
    flex: 1,
    field: 'unitName',
    maxWidth: 120,
    hideable: false,
    headerName: 'Unit name',
    renderCell: params => renderCell(params.row.unitName, true),
    renderHeader: () => renderHeader(t('allocations.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'right',
    field: 'residentName',
    flex: 1,
    maxWidth: 300,
    headerName: 'Active residents',
    renderCell: params => {
      if (params.row.residentAccountId) {
        return renderCell(store.account.profilesFullName.get(params.row.residentAccountId), true);
      } else {
        return renderCell(t('allocations.not_enrolled'), true);
      }
    },
    renderHeader: () => renderHeader(t('allocations.active_residents', {
      activeResidents: "".concat(store.allocations.table.enrolledUnitsCount, "/").concat(store.allocations.table.totalUnitsCount),
      interpolation: {
        escapeValue: false
      }
    }))
  }, {
    align: 'right',
    field: 'statementCap',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Monthly caps',
    renderCell: params => renderCell(params.row.statementCap !== null ? '$' + params.row.statementCap : t('allocations.not_set')),
    renderHeader: () => renderHeader(t('allocations.statement_caps'), true)
  }, {
    align: 'right',
    field: 'utilityCaps',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Utility caps',
    renderCell: params => renderCell(isValueNumber(params.row.utilityCaps) ? '$' + params.row.utilityCaps : t('allocations.not_set')),
    renderHeader: () => renderHeader(t('allocations.utility_caps'), true)
  }, {
    align: 'right',
    field: 'utilityCharges',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Utility charges',
    renderCell: params => renderCell('$' + params.row.utilityCharges),
    renderHeader: () => renderHeader(t('allocations.utility_charges'), true)
  }, {
    align: 'right',
    field: 'totalStatement',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Total statement',
    renderCell: params => renderCell('$' + params.row.totalStatement),
    renderHeader: () => renderHeader(t('allocations.total_statement'), true)
  }];
  const trigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: "action",
    'custom-attribute': '118-allocation-preview-cycle-charges'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-search"
  }), t('allocations.preview_cycle_charges'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabled,
    noPadding: true,
    title: t('allocations.preview_cycle_charges'),
    trigger: trigger,
    variant: "middle"
  }, /*#__PURE__*/React.createElement(DataGrid, {
    columns: columns,
    getRowId: row => row.id,
    pageSize: pageSize,
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    disableRowSelectionOnClick: true,
    autoHeight: true,
    columnHeaderHeight: 80,
    rowHeight: 60,
    hideFooterSelectedRowCount: true,
    getRowClassName: () => classes.row,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '119-allocation-preview-cycle-charges'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    rows: (_store$allocations$ch = store.allocations.chargesPreviewForSelectedCycle) === null || _store$allocations$ch === void 0 ? void 0 : _store$allocations$ch.map((c, i) => _objectSpread(_objectSpread({}, c), {}, {
      id: i
    }))
  }));
});
export default PreviewCycleChargesModal;